<template>
  <section v-if="data.length > 0" class="container">
    <h3 class="!mb-12">Articles like this</h3>
    <div
      class="grid grid-cols-1 gap-12 md:grid-cols-2 md:gap-x-16 md:gap-y-12 lg:grid-cols-3 lg:gap-16"
    >
      <div v-for="(article, idx) in data" :key="idx">
        <SbBlogCard
          :link="`/${article.full_slug}/`"
          :full_slug="true"
          :img="article.content.image"
          category=""
          :title="article.content.title"
          :desc="sbArticleContentSanitiser(article.content.articleContent)"
          :date="article.content.publishedDate"
        />
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import type { ISbStoryData } from "storyblok-js-client";

const props = defineProps<{
  tags: string[];
  segment: string;
  currentStory: string | undefined;
}>();

const articles = await getRelatedBlogStoryBlokData(
  props.segment,
  props.tags.length > 0 ? props.tags : undefined,
  props.currentStory,
);

const { data } = await useAsyncData("article-state", async () => {
  if (articles.length > 3) {
    const uniqueIndices: number[] = [];
    while (uniqueIndices.length < 3) {
      const randomIndex = Math.floor(Math.random() * articles.length);
      if (!uniqueIndices.includes(randomIndex)) uniqueIndices.push(randomIndex);
    }
    const threeRelatedArticles: ISbStoryData[] = [];
    uniqueIndices.forEach((idx: number) =>
      threeRelatedArticles.push(articles[idx]),
    );
    return threeRelatedArticles;
  } else {
    return articles;
  }
});
</script>
